function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import { Draw, Select } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import { Style, Fill, Stroke, Circle } from 'ol/style';
import { click } from 'ol/events/condition';
import { ensureMap } from '../../hocs/ensureMap';
import { provideMapState } from '../../hocs/provideMapState';
import { LegacyVectorLayer } from './LegacyVectorLayer';
import { getCenter } from 'ol/extent';
import { Point } from 'ol/geom';
var defaultFontColor = 'rgb(255, 255, 255)';
var defaultFillColor = 'rgb(238, 153, 0)';
var defaultOpacity = 100;
var defaultPointRadius = 10;
var defaultStrokeWidth = 2;
var defaultModifyCircleFillColor = 'rgb(27, 140, 247)';
var defaultModifyCircleStrokeColor = 'rgb(27, 140, 247)';
var defaultModifyCircleRadius = 5;
var defaultModifyFillColor = 'rgb(27, 140, 247)';
var defaultModifyStrokeColor = 'rgb(27, 140, 247)';
var defaultLineDash = [];
var defaultLineDashOffset = 0;
var LayerStyle = PropTypes.shape({
  pointRadius: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  modifyCircleFillOpacity: PropTypes.number,
  modifyCircleStrokeOpacity: PropTypes.number,
  modifyCircleStrokeColor: PropTypes.string,
  modifyCircleRadius: PropTypes.number,
  modifyCircleFillColor: PropTypes.string,
  modifyFillColor: PropTypes.string,
  modifyFillOpacity: PropTypes.number,
  modifyStrokeColor: PropTypes.string,
  modifyStrokeOpacity: PropTypes.number,
  lineDash: PropTypes.array,
  lineOffset: PropTypes.number
});
function hexToRGB(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity / 100 + ')';
}
function createRGB(rgb, opacity) {
  if (rgb.indexOf('rgb') > -1) {
    return rgb;
  }
  return 'rgba(' + rgb.replace(/\s/g, ',') + ', ' + opacity / 100 + ')';
}
function convertColor(value, opacity) {
  if (value.indexOf('#') > -1) {
    return hexToRGB(value, opacity);
  } else {
    return createRGB(value, opacity);
  }
}
function getFeatureStyle(featureStyle) {
  featureStyle = featureStyle || {};
  var _featureStyle = featureStyle,
    pointRadius = _featureStyle.pointRadius,
    fillColor = _featureStyle.fillColor,
    fillOpacity = _featureStyle.fillOpacity,
    strokeColor = _featureStyle.strokeColor,
    strokeOpacity = _featureStyle.strokeOpacity,
    strokeWidth = _featureStyle.strokeWidth,
    fontColor = _featureStyle.fontColor,
    modifyCircleFillColor = _featureStyle.modifyCircleFillColor,
    modifyCircleStrokeColor = _featureStyle.modifyCircleStrokeColor,
    modifyCircleRadius = _featureStyle.modifyCircleRadius,
    modifyCircleFillOpacity = _featureStyle.modifyCircleFillOpacity,
    modifyCircleStrokeOpacity = _featureStyle.modifyCircleStrokeOpacity,
    modifyFillColor = _featureStyle.modifyFillColor,
    modifyStrokeColor = _featureStyle.modifyStrokeColor,
    modifyFillOpacity = _featureStyle.modifyFillOpacity,
    modifyStrokeOpacity = _featureStyle.modifyStrokeOpacity,
    modifyStrokeWidth = _featureStyle.modifyStrokeWidth,
    lineDash = _featureStyle.lineDash,
    lineDashOffset = _featureStyle.lineDashOffset;
  return {
    strokeWidth: strokeWidth || defaultStrokeWidth,
    strokeColor: convertColor(strokeColor || fillColor || defaultFillColor, strokeOpacity || defaultOpacity),
    fillColor: convertColor(fillColor || defaultFillColor, fillOpacity || defaultOpacity),
    fontColor: convertColor(fontColor || defaultFontColor),
    pointRadius: pointRadius || defaultPointRadius,
    modifyCircleRadius: modifyCircleRadius || defaultModifyCircleRadius,
    modifyCircleFillColor: convertColor(modifyCircleFillColor || defaultModifyCircleFillColor, modifyCircleFillOpacity || defaultOpacity),
    modifyCircleStrokeColor: convertColor(modifyCircleStrokeColor || defaultModifyCircleStrokeColor, modifyCircleStrokeOpacity || defaultOpacity),
    modifyFillColor: convertColor(modifyFillColor || defaultModifyFillColor, modifyFillOpacity || defaultOpacity),
    modifyStrokeColor: convertColor(modifyStrokeColor || defaultModifyStrokeColor, modifyStrokeOpacity || defaultOpacity),
    modifyStrokeWidth: modifyStrokeWidth || defaultStrokeWidth,
    lineDash: lineDash || defaultLineDash,
    lineDashOffset: lineDashOffset || defaultLineDashOffset
  };
}

/**
 *
 * @deprecated This is replaced by new VectorLayer and Select interaction
 */
var SelectLayer = /*#__PURE__*/function (_LegacyVectorLayer) {
  function SelectLayer(props) {
    var _this;
    _this = _LegacyVectorLayer.call(this, props) || this;
    _this.selectFeaturesByIntersect = _this.selectFeaturesByIntersect.bind(_this);
    _this.onFeaturesSelected = _this.onFeaturesSelected.bind(_this);
    return _this;
  }
  _inheritsLoose(SelectLayer, _LegacyVectorLayer);
  var _proto = SelectLayer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    _LegacyVectorLayer.prototype.componentDidMount.call(this);
    var _this$props = this.props,
      map = _this$props.map,
      layerName = _this$props.layerName,
      clusterThreshold = _this$props.clusterThreshold,
      hitTolerance = _this$props.hitTolerance;
    var featureStyle = this.props.featureStyle;
    var layer = map._vectorLayers[layerName].layer;
    featureStyle = getFeatureStyle(featureStyle);
    var drawInt = new Draw({
      type: 'Polygon',
      style: new Style({
        fill: new Fill({
          color: featureStyle.modifyFillColor
        }),
        stroke: new Stroke({
          color: featureStyle.modifyStrokeColor,
          width: featureStyle.modifyStrokeWidth,
          lineDash: featureStyle.lineDash,
          lineDashOffset: featureStyle.lineDashOffset
        }),
        image: new Circle({
          radius: featureStyle.modifyCircleRadius,
          fill: new Fill({
            color: featureStyle.modifyCircleFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyCircleStrokeColor,
            width: featureStyle.modifyCircleStrokeWidth
          })
        })
      })
    });
    var selectInt = new Select({
      type: 'SelectPoint',
      condition: click,
      multi: true,
      hitTolerance: hitTolerance
    });
    var lineInt = new Draw({
      type: 'LineString',
      style: new Style({
        fill: new Fill({
          color: featureStyle.modifyFillColor
        }),
        stroke: new Stroke({
          color: featureStyle.modifyStrokeColor,
          width: featureStyle.modifyStrokeWidth,
          lineDash: featureStyle.lineDash,
          lineDashOffset: featureStyle.lineDashOffset
        }),
        image: new Circle({
          radius: featureStyle.modifyCircleRadius,
          fill: new Fill({
            color: featureStyle.modifyCircleFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyCircleStrokeColor,
            width: featureStyle.modifyCircleStrokeWidth
          })
        })
      })
    });
    var boxInt = new Draw({
      type: 'Circle',
      geometryFunction: createBox(),
      style: new Style({
        fill: new Fill({
          color: featureStyle.modifyFillColor
        }),
        stroke: new Stroke({
          color: featureStyle.modifyStrokeColor,
          width: featureStyle.modifyStrokeWidth,
          lineDash: featureStyle.lineDash,
          lineDashOffset: featureStyle.lineDashOffset
        }),
        image: new Circle({
          radius: featureStyle.modifyCircleRadius,
          fill: new Fill({
            color: featureStyle.modifyCircleFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyCircleStrokeColor,
            width: featureStyle.modifyCircleStrokeWidth
          })
        })
      })
    });
    if (clusterThreshold) {
      var clusterSource = layer.getSource();
      clusterSource.geometryFunction = function (feature) {
        if (selectInt.getFeatures().getArray().find(function (f) {
          return f.getId() === feature.getId();
        })) {
          return;
        }
        var extent = feature.getGeometry().getExtent();
        var center = getCenter(extent);
        return new Point(center);
      };
    }
    map._vectorLayers[layerName].drawInt = drawInt;
    map._vectorLayers[layerName].selectInt = selectInt;
    map._vectorLayers[layerName].lineInt = lineInt;
    map._vectorLayers[layerName].boxInt = boxInt;
    this.setLayer();
    this.useSelectFeatures();
  };
  _proto.setLayer = function setLayer() {
    var _this$props2 = this.props,
      map = _this$props2.map,
      layerName = _this$props2.layerName;
    var _map$_vectorLayers$la = map._vectorLayers[layerName],
      drawInt = _map$_vectorLayers$la.drawInt,
      selectInt = _map$_vectorLayers$la.selectInt,
      lineInt = _map$_vectorLayers$la.lineInt,
      boxInt = _map$_vectorLayers$la.boxInt;
    this.bindListeners();
    map.addInteraction(drawInt);
    map.addInteraction(selectInt);
    map.addInteraction(lineInt);
    map.addInteraction(boxInt);
    this.toggleInteractions(this.props);
  };
  _proto.bindListeners = function bindListeners() {
    var _this2 = this;
    var _this$props3 = this.props,
      map = _this$props3.map,
      layerName = _this$props3.layerName,
      keepPolygonOnDrawend = _this$props3.keepPolygonOnDrawend,
      multiPolygonInteraction = _this$props3.multiPolygonInteraction,
      features = _this$props3.features;
    var _map$_vectorLayers$la2 = map._vectorLayers[layerName],
      drawInt = _map$_vectorLayers$la2.drawInt,
      selectInt = _map$_vectorLayers$la2.selectInt,
      lineInt = _map$_vectorLayers$la2.lineInt,
      boxInt = _map$_vectorLayers$la2.boxInt,
      layerSource = _map$_vectorLayers$la2.layerSource;
    if (keepPolygonOnDrawend && multiPolygonInteraction) {
      drawInt.on('drawend', function (evt) {
        setTimeout(function () {
          layerSource.addFeature(evt.feature);
          _this2.selectFeaturesByIntersect(evt.feature, selectInt);
        }, 50);
      }, this);
    } else if (keepPolygonOnDrawend) {
      drawInt.on('drawstart', function () {
        selectInt.getFeatures().clear();
        layerSource.clear();
        layerSource.addFeatures(features);
      });
      drawInt.on('drawend', function (evt) {
        setTimeout(function () {
          layerSource.addFeature(evt.feature);
          _this2.selectFeaturesByIntersect(evt.feature, selectInt);
        }, 50);
      }, this);
    } else {
      drawInt.on('drawstart', function () {
        selectInt.getFeatures().clear();
      });
      drawInt.on('drawend', function (evt) {
        setTimeout(function () {
          _this2.selectFeaturesByIntersect(evt.feature, selectInt);
        }, 50);
      }, this);
    }
    selectInt.on('select', function (evt) {
      setTimeout(function () {
        layerSource.clear();
        layerSource.addFeatures(features);
        _this2.onFeaturesSelected(evt.feature, selectInt);
      }, 50);
    });
    boxInt.on('drawstart', function () {
      selectInt.getFeatures().clear();
      layerSource.clear();
      layerSource.addFeatures(features);
    });
    boxInt.on('drawend', function (evt) {
      setTimeout(function () {
        layerSource.addFeature(evt.feature);
        _this2.selectFeaturesByIntersect(evt.feature, selectInt);
      }, 50);
    }, this);
    lineInt.on('drawend', function (evt) {
      setTimeout(function () {
        layerSource.addFeature(evt.feature);
        _this2.selectFeaturesByIntersect(evt.feature, selectInt);
      }, 50);
    }, this);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    _LegacyVectorLayer.prototype.componentDidUpdate.call(this);
    this.toggleInteractions(this.props);
    this.useSelectFeatures(prevProps);
  };
  _proto.toggleInteractions = function toggleInteractions(props) {
    var map = props.map,
      layerName = props.layerName,
      interactionType = props.interactionType;
    var _map$_vectorLayers$la3 = map._vectorLayers[layerName],
      drawInt = _map$_vectorLayers$la3.drawInt,
      selectInt = _map$_vectorLayers$la3.selectInt,
      lineInt = _map$_vectorLayers$la3.lineInt,
      boxInt = _map$_vectorLayers$la3.boxInt;
    drawInt && drawInt.setActive(interactionType === 'Polygon');
    selectInt && selectInt.setActive(interactionType === 'SelectPoint');
    lineInt && lineInt.setActive(interactionType === 'LineString');
    boxInt && boxInt.setActive(interactionType === 'DrawBox');
  };
  _proto.onFeaturesSelected = function onFeaturesSelected(features, currentInt) {
    features = currentInt.getFeatures().getArray();
    var selectedFeatures = [];
    features && features.forEach(function (f) {
      var tmpF = f.get('features');
      if (tmpF) {
        selectedFeatures = selectedFeatures.concat(tmpF);
      } else {
        selectedFeatures.push(f);
      }
    });
    currentInt.getFeatures().clear();
    currentInt.getFeatures().extend(selectedFeatures);
    this.props.onFeaturesSelected(currentInt.getFeatures().getArray());
  };
  _proto.selectFeaturesByIntersect = function selectFeaturesByIntersect(sf, currentInt) {
    var extent = sf.getGeometry().getExtent();
    var _this$props4 = this.props,
      map = _this$props4.map,
      layerName = _this$props4.layerName,
      onFeaturesSelected = _this$props4.onFeaturesSelected;
    var layerSource = map._vectorLayers[layerName].layerSource;
    if (!sf) return;
    layerSource.forEachFeatureIntersectingExtent(extent, function (feature) {
      if (sf.getGeometry().intersectsCoordinate(feature.getGeometry().getCoordinates())) {
        var currentFeaturesArr = currentInt.getFeatures().getArray();
        if (currentFeaturesArr.includes(feature) === false) {
          currentInt.getFeatures().push(feature);
        }
      }
    });
    onFeaturesSelected(currentInt.getFeatures().getArray());
  };
  _proto.useSelectFeatures = function useSelectFeatures(prevProps) {
    var _this3 = this;
    var _this$props5 = this.props,
      selectFeatures = _this$props5.selectFeatures,
      map = _this$props5.map,
      layerName = _this$props5.layerName;
    var selectInt = map._vectorLayers[layerName].selectInt;
    var shouldUpdate = false;
    if (!selectFeatures) {
      return;
    }
    if (prevProps && !prevProps.selectFeatures && selectFeatures) {
      shouldUpdate = true;
    }
    if (prevProps && prevProps.selectFeatures && !selectFeatures || prevProps && prevProps.selectFeatures.length && !selectFeatures.length) {
      shouldUpdate = true;
    }
    if (!shouldUpdate && prevProps && prevProps.selectFeatures) {
      selectFeatures.forEach(function (sf) {
        if (!prevProps.selectFeatures.find(function (psf) {
          return psf.getId() === sf.getId();
        })) {
          shouldUpdate = true;
          return;
        }
      });
    }
    if (shouldUpdate) {
      selectInt.getFeatures().clear();
      if (selectFeatures && selectFeatures.length > 0) {
        selectFeatures.forEach(function (sf) {
          return _this3.selectFeaturesByIntersect(sf, selectInt);
        });
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    _LegacyVectorLayer.prototype.componentWillUnmount.call(this);
    var _this$props6 = this.props,
      map = _this$props6.map,
      layerName = _this$props6.layerName;
    var _map$_vectorLayers$la4 = map._vectorLayers[layerName],
      drawInt = _map$_vectorLayers$la4.drawInt,
      selectInt = _map$_vectorLayers$la4.selectInt,
      lineInt = _map$_vectorLayers$la4.lineInt,
      boxInt = _map$_vectorLayers$la4.boxInt,
      layerSource = _map$_vectorLayers$la4.layerSource;
    map.removeInteraction(drawInt);
    map.removeInteraction(selectInt);
    map.removeInteraction(lineInt);
    map.removeInteraction(boxInt);
    layerSource.clear();
  };
  return SelectLayer;
}(LegacyVectorLayer);
/** @component */
_defineProperty(SelectLayer, "propTypes", {
  featureStyle: LayerStyle,
  onFeaturesSelected: PropTypes.func.isRequired,
  selectFeatures: PropTypes.array,
  hitTolerance: PropTypes.number
});
export default provideMapState(ensureMap(SelectLayer));